import { useTypedParams } from "react-router-typesafe-routes";

import { ClientNotificationsCard } from "@components/Cards/ClientNotificationsCard/ClientNotificationsCard";

import { routes } from "@pages/routes";

export const ClientNotificationHistory = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client);

  return <ClientNotificationsCard clientId={clientId} viewMode="history" />;
};
